import { FilledButton } from '../util/button';
import '../util/bpUtilStyle.css';

interface PickUpReserveDialogCardProps {
  onClick: () => void;
}
export const PickUpReserveDialogCard = ({
  onClick,
}: PickUpReserveDialogCardProps) => {
  const dialogLabel = 'ご返却日の予約を受け付けました';
  const dialogText = [
    'ご予約ありがとうございます。',
    '予約詳細からご確認いただけます。',
    '工場の都合で、第一希望に添えない場合は',
    '工場からご連絡いたします。',
  ];
  return (
    <div className={'dialog-card'}>
      <div className={'message-field'}>
        <div className={'message-header'}>
          <span>{dialogLabel}</span>
        </div>
        <div className={'message-body'}>
          {dialogText.map((item, idx) => (
            <span key={idx}>{item}</span>
          ))}
        </div>
      </div>
      <FilledButton onClick={onClick} label={'予約内容を確認する'} />
    </div>
  );
};
